import type { Theme } from '../../types/theme';

export const intercomTheme: Theme = {
  id: 'intercom',
  name: 'Intercom',
  description: 'Soft cream canvas with Saans typography and charcoal CTAs',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/intercom/DESIGN.md',
  visualKeywords: ['warm cream', 'Saans font', 'Fin Orange', 'charcoal CTA', 'conversational'],
  colors: {
    background: '#f5f1ec',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#111111',
    textSecondary: '#626260',
    textMuted: '#626260',
    border: '#d3cec6',
    borderSubtle: '#c9c4bc',
    primary: '#111111',
    primaryHover: '#202020',
    primaryActive: '#000000',
    accent: '#111111',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'conversational',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
